const itemsList = require('../itemsList/itemsList');

const eventsCalendar = Object.assign({}, itemsList, {
    subelements: {
        secondaryFiltersToggler: false,
        exportFiltersToggler: false,
        settingsFiltersToggler: false,
        appliedFilters: false,
        calendar: false
    },
    initDate: false,
    lang: 'en',
    actionsConfig: {},
    calendarActions: {},
    calendarObj: false,

    init: function () {
        itemsList.init.call(this);

        this.initCalendar();
    },

    initCalendar: function () {
        this.calendarObj = new FullCalendar.Calendar(this.subelements.calendar, {
            aspectRatio: 1.8,
            headerToolbar: {
                left: 'prev,next today',
                center: 'title',
                right: 'dayGridMonth,timeGridWeek,timeGridDay,listMonth'
            },
            views: {
                dayGridMonth: { buttonText: 'month' },
                timeGridWeek: { buttonText: 'week' },
                timeGridDay: { buttonText: 'day' }
            },
            eventTimeFormat: {
                hour: '2-digit',
                minute: '2-digit',
                hour12: false // This enables 24-hour format
            },
            displayEventEnd: true,
            initialView: 'dayGridMonth',
            initialDate: this.initDate,
            locale: this.lang,
            editable: true,
            dayMaxEvents: true, // allow "more" link when too many events
            navLinks: true,
            events: (fetchInfo, successCallback, failureCallback) => {
                if (typeof this.hm.app.components[this.id + '_f_initDate'] !== typeof undefined) {
                    let initDate = this.calendarObj === false ? this.initDate : this.calendarObj.currentData.currentDate;

                    if (!this.hm.helper.isString(initDate)) {
                        initDate = this.toString(initDate);
                    }

                    this.hm.app.components[this.id + '_f_initDate'].setValue(initDate);
                    this.hm.app.components[this.id + '_f_fromDate'].setValue(this.toString(fetchInfo.start));
                    this.hm.app.components[this.id + '_f_toDate'].setValue(this.toString(fetchInfo.end));
                } else {
                    this.hm.log('month filter not found');
                }

                let calEventsPromise = this.getItems();

                calEventsPromise.then(
                    (data) => {
                        successCallback(data.calEvents);
                        this.postLoadEvents(data.response);
                    },
                    (err) => { failureCallback(err) }
                );
            },
            dateClick: (info) => { info.jsEvent.preventDefault(); this.dateClick(info.dateStr); },
            eventClick: (info) => { info.jsEvent.preventDefault(); this.eventClick(info.event); },
        });

        this.calendarObj.render();
    },

    dateClick: function (dateStr) {
        let params = Object.assign({}, this.actionsConfig.date.postParams, { date: dateStr });

        let paramsStr = JSON.stringify(params);
        let hash = this.hm.helper.insecureHash(paramsStr);

        if (typeof this.calendarActions[hash] === typeof undefined && typeof this.actionsConfig.date !== typeof undefined && typeof this.actionsConfig.date.controller !== typeof undefined && this.actionsConfig.date.controller) {
            let action = this.hm.newComponent(this.actionsConfig.date.component);
            action.element = document.createElement('a');
            action.id = 'dateClick_' + hash;
            action.form = this.form;
            action.method = 'POST';
            action.controller = this.actionsConfig.date.controller;
            action.action = this.actionsConfig.date.action;
            action.formParams = this.actionsConfig.date.formParams;
            action.postParams = params;
            this.calendarActions[hash] = action;
        }

        if (typeof this.calendarActions[hash] !== typeof undefined) {
            this.calendarActions[hash].act();
        }
    },

    eventClick: function (eventObj) {
        //this.hm.log('event click', eventObj, this.actionsConfig.event);
        let params = Object.assign({}, this.actionsConfig.event.postParams, { id: eventObj._def.publicId });

        let paramsStr = JSON.stringify(params);
        let hash = this.hm.helper.insecureHash(paramsStr);

        if (typeof this.calendarActions[hash] === typeof undefined && typeof this.actionsConfig.event !== typeof undefined && typeof this.actionsConfig.event.controller !== typeof undefined && this.actionsConfig.event.controller) {
            let action = this.hm.newComponent(this.actionsConfig.event.component);
            action.element = document.createElement('a');
            action.id = 'eventClick_' + hash;
            action.form = this.form;
            action.method = 'POST';
            action.link = eventObj._def.url;
            action.controller = this.actionsConfig.event.controller;
            action.action = this.actionsConfig.event.action;
            action.formParams = this.actionsConfig.event.formParams;
            action.postParams = params;

            this.calendarActions[hash] = action;
        }

        if (typeof this.calendarActions[hash] !== typeof undefined) {
            this.calendarActions[hash].act();
        }
    },

    clearList: function () {
        if (this.calendarObj !== false) {
            this.calendarObj.getEvents().forEach((calEvent) => {
                calEvent.remove();
            });
        }
    },

    loadItems: async function (triggerComponent) {
        if (this.calendarObj !== false) {
            this.clearList();

            this.calendarObj.refetchEvents();
        }
    },

    postLoadEvents: async function (response) {
        if (typeof response.appliedFilters !== typeof undefined) {
            await this.appliedFilters(response);
        }

        this.dispatch('zitLoaded', { response: response });
    },

    itemsActions: function (response) {
    },

    displayItems: function (response) {

    },

    getItems: async function (resetFilters = false) {
        let response = await itemsList.getItems.call(this, resetFilters);

        if (typeof response.needsReload !== typeof undefined) {
            window.location.reload();
            return [];
        }

        let calEvents = [];

        //to do: response items should be raw items, not components

        response.items.forEach((responseItem) => {
            let item = responseItem.item;

            let startDateObj = this.hm.helper.datetimeString2Date(item.start);
            let endDateObj = this.hm.helper.datetimeString2Date(item.end);

            let allDay = startDateObj.getHours() === 0 && startDateObj.getMinutes() === 0 && startDateObj.getSeconds() === 0 && endDateObj.getHours() === 23 && endDateObj.getMinutes() === 59 && endDateObj.getSeconds() === 59;

            let classNames = [];

            if (typeof item.cssClass !== typeof undefined) {
                classNames.push(item.cssClass);
            }

            let calEvent = {
                id: item.id,
                allDay: allDay,
                title: item.title,
                start: startDateObj,
                end: endDateObj,
                classNames: classNames,
                url: typeof item.url !== typeof undefined ? item.url : ''
            };

            calEvents.push(calEvent);
        });

        //this.hm.log('get items', response.items);

        return { calEvents: calEvents, response: response };
    },

    displayNoItems: function () {

    },

    toString: function (dateObj) {
        let year = dateObj.getFullYear().toString();
        let month = dateObj.getMonth();
        month++
        month = month.toString();

        if (month.length === 1) {
            month = '0' + month;
        }

        let day = dateObj.getDate();
        day = day.toString();

        if (day.length === 1) {
            day = '0' + day;
        }

        return year + '-' + month + '-' + day;
    }
});

module.exports = eventsCalendar